/**
 * Route for `encryption-posture`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EncryptionPosturePage } from "../features/encryption-posture/EncryptionPosturePage";

export const encryptionPostureRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/encryption-posture",
	component: EncryptionPosturePage,
});

export default encryptionPostureRoute;
